import { twMerge } from 'tailwind-merge';

export default function Label({ value, className = '', children, ...props }) {
    return (
        <label {...props} className={twMerge(`block text-sm font-medium mb-2 dark:text-white`, className)}>
            {value ? value : children}
        </label>
    );
}